import type {
	BaseMetricDataWithStartAndStop,
	BasePageLoadMetricDataWithStartAndStop,
	PageVisibleState,
	PerformanceEventConfig,
} from '../../types';

export const pageVisibleState = (
	_config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop | BasePageLoadMetricDataWithStartAndStop,
): {
	'pageVisible:state': PageVisibleState;
} => {
	return {
		'pageVisible:state': data.pageVisibleState,
	};
};
